const IconField = ({ icon, children, iconSize = 18 }) => {
  const IconComponent = icon;

  return (
    <div className="relative mt-1">
      <IconComponent
        size={iconSize}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-primaryColor"
      />
      {children}
    </div>
  );
};

export default IconField;
